"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCreateCommsSessionBody = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateCreateCommsSessionBody = (0, validation_1.properties)({
    OS: (0, validation_1.optional)((0, validation_1.text)()),
});
//# sourceMappingURL=CreateCommsSessionBody.js.map